<h2 mat-dialog-title>Alert configuration</h2>

<mat-dialog-content class="campaign-alert-config-dialog">
  <mat-form-field appearance="fill" floatLabel="always" class="campaign-alert-config-dialog__full">
    <mat-label>Campaign title</mat-label>
    <input matInput [value]="data.title" disabled />
  </mat-form-field>
  <mat-form-field appearance="fill" floatLabel="always" class="campaign-alert-config-dialog__full">
    <mat-label>Description</mat-label>
    <textarea matInput rows="2" [value]="data.description ?? ''" disabled></textarea>
  </mat-form-field>
  <mat-form-field appearance="fill" floatLabel="always" class="campaign-alert-config-dialog__full">
    <mat-label>Callback location</mat-label>
    <input matInput [value]="data.locationLabel?.trim() || '—'" disabled />
  </mat-form-field>

  <h3 class="campaign-alert-config-dialog__subsection">Alert configuration</h3>
  <app-alert-config-form-fields
    [form]="alertConfigForm"
    [readOnly]="true"
    [showCampaignSchedule]="true"
    [cycleSlots]="cycleSlots"
    [customScheduleControl]="customScheduleEnabled"
  />
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" type="button" (click)="onClose()">Close</button>
</mat-dialog-actions>
